import {Component, signal, ViewEncapsulation} from '@angular/core';
import {IconComponent} from '../icon/icon.component';

@Component({
  selector: 'app-drop-down-button',
  imports: [
    IconComponent
  ],
  templateUrl: './drop-down-button.component.html',
  styleUrl: './drop-down-button.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'd-block position-relative'
  }
})
export class DropDownButtonComponent {
  protected readonly popoverId = crypto.randomUUID()

  protected beforeToggle(button: HTMLElement, menu: HTMLElement) {
    const rect = button.getBoundingClientRect()
    menu.style.top = `${rect.bottom}px`
    menu.style.left = `${rect.left}px`
  }

  protected close(event: Event) {
    event.stopPropagation()
  }
}
